<template>
  <SectionWrapper sectionId="contact" :isNavy="true">
    <SectionContainer>
      <Heading :titleImgSrc="headingData.img" :titleText="headingData.text" :leading="headingData.leading" :description="headingData.description" />
      <ContentContainer>
        <div class="contact">
          <div class="contact_button">
            <LinkButton href="https://www.ctc-g.co.jp/inquiry/q322/" color="white" shape="border">お問い合わせ</LinkButton>
            <p class="contact_button_lead">サービスの導入・検討にあたってのご質問は、こちらからお問い合わせください。</p>
          </div>
          <div class="contact_button">
            <LinkButton href="https://www.business-on-it.com/datasheet/2010-datasheet-request-dx-build" color="purple" shape="solid">資料ダウンロード</LinkButton>
            <p class="contact_button_lead">サービスに関する詳しい説明はこちらから無料でダウンロードが可能です。</p>
          </div>
        </div>
      </ContentContainer>
    </SectionContainer>
  </SectionWrapper>
</template>

<script>
import Heading from '../atoms/Heading'
import SectionWrapper from '../atoms/SectionWrapper'
import SectionContainer from '../atoms/SectionContainer'
import ContentContainer from '../atoms/ContentContainer'
import LinkButton from '../atoms/LinkButton'

export default {
  name: 'contact',
  components: {
    Heading,
    SectionWrapper,
    SectionContainer,
    ContentContainer,
    LinkButton
  },
  data () {
    return {
      headingData: {
        img: require('@/assets/images/title_contact.svg'),
        text: 'contact',
        leading: 'お問い合わせ',
        description: ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.contact {
  display: flex;
  @include bpOnlyPc() {
    flex-direction: row;
    justify-content: center;
  }
  @include bpOnlySp() {
    flex-direction: column;
    align-items: center;
  }
  &_button {
    display: flex;
    flex-direction: column;
    &:last-of-type {
      @include bpOnlyPc() {
        margin-left: 88px;
      }
      @include bpOnlySp() {
        margin-top: 60px;
      }
    }
    &_lead {
      max-width: 360px;
      margin-top: 24px;
      font-size: 14px;
      font-weight: bold;
      line-height: 1.8;
      color: $white;
      text-align: left;
    }
  }
}
</style>
